var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-team-avatar",class:[
    {'active': _vm.isActive}
  ],style:({width: `${_vm.width}px`, height: `${_vm.height}px`})},[(_vm.image)?_c('div',{staticClass:"aha-team-avatar__image",class:[
      {'hover' : _vm.isHover, circle: _vm.circle},
    ],style:({width: `${_vm.width-3}px`, height: `${_vm.height-3}px`})},[_c('img',{attrs:{"src":_vm.image}})]):_c('div',{staticClass:"aha-team-avatar__image",class:[
      {'hover' : _vm.isHover, circle: _vm.circle},
    ],style:({backgroundColor: _vm.avatarColor, width: `${_vm.width-3}px`, height: `${_vm.height-3}px`})},[_vm._v("\n    "+_vm._s(_vm._f("textAvatar")(_vm.showingName))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }